import { connect } from 'react-redux';
import { showMobileDeviationSharePopup } from '../../../Modals/redux/actionCreators';
import { showReportModal } from '../../../Moderation/redux/actions';
import { shareDeviationToPost } from '../../../redux/deviations/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../../redux/deviations/selectors';
var mapStateToProps = function (state, props) { return ({
    isOwner: getIsCurrentUserAuthorOf(state, props.deviation),
}); };
var mapDispatchToProps = function (dispatch, props) { return ({
    showReportModal: function () { return dispatch(showReportModal(props.deviation)); },
    showMobileDeviationSharePopup: function () {
        return dispatch(showMobileDeviationSharePopup(props.deviation));
    },
    shareDeviationToPost: function () { return dispatch(shareDeviationToPost(props.deviation)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=MoreButton.container.js.map